import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box, ButtonBase, LinearProgress, Tooltip } from "@material-ui/core"

const defaultSize = { height: 38, width: 149 }
const sizes = {}
const svgs = require.context("../../assets/images/banks", false, /\.(svg|png)$/)

const logos = svgs.keys().reduce((acc, cur) => {
  const name = cur.replace("./", "").replace(/\.(svg|png)$/, "")

  acc[name] = svgs(cur)

  return acc
}, {})

export function DownloadPaymentSlipButton({ code, onClick, ...props }) {
  const [isDownloading, setIsDownloading] = useState(false)

  const image = logos[code]
  const size = sizes[code] || defaultSize

  // const [isLoading, setIsLoading] = useState(false)

  // async function handleClick(...args) {
  //   setIsLoading(true)

  //   await onClick(args)

  //   setIsLoading(false)
  // }

  async function handleDownload() {
    setIsDownloading(true)

    await onClick()

    setIsDownloading(false)
  }

  return (
    <Tooltip
      title={
        isDownloading ? "Baixando..." : "Clique para baixar o boleto do título"
      }
    >
      {isDownloading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={2}
        >
          <Box width={60} height={28}>
            <LinearProgress color="primary" variant="indeterminate" />
          </Box>
        </Box>
      ) : image ? (
        <ButtonBase {...props} onClick={handleDownload}>
          <img
            src={image}
            alt={code}
            width={size.width}
            height={size.height}
            style={{
              transform: "scale(0.75)",
            }}
          />
        </ButtonBase>
      ) : (
        <ButtonBase size="large" disabled {...props} color="primary">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={defaultSize.width}
            height={defaultSize.height}
          >
            Download indisponível
          </Box>
        </ButtonBase>
      )}
    </Tooltip>
  )
}

DownloadPaymentSlipButton.propTypes = {
  code: PropTypes.string,
  isActive: PropTypes.bool,
}
